// 英文语言包（en-US）——覆盖关键框架页；未提供的键经 fallbackLocale 回退 zh-CN。
export default {
  brand: {
    name: "Letoo AI",
    slogan: "Not just advice — we get AI actually growing into your business",
    subSlogan:
      "Forward Deployed Engineers deliver from business diagnosis to private deployment — first results in as little as 2 weeks.",
  },
  common: {
    ctaDiagnosis: "Schedule A Meeting",
    ctaJoin: "Add WeCom to Join",
    exploreMore: "Explore more",
    bookingUrl: "https://meetings-na2.hubspot.com/gf",
    disclaimer: "Some cases are anonymized demonstrations.",
    qrDialogTitle: "Contact Us",
    qrDialogCaption: "Scan to add us on WeCom",
    businessPhone: "Business phone",
  },
  nav: {
    home: "Home",
    solutions: "Solutions",
    cases: "Cases",
    fde: "FDE Delivery",
    courses: "Courses",
    community: "Community",
    about: "About",
  },
  home: {
    hero: {
      eyebrow: "Enterprise AI Deployment",
      title: "Not just advice — ",
      titleSpan: "we get AI actually growing into your business",
      line3: "FDE delivery, results in as little as 2 weeks",
      ctaPrimary: "Free AI Assessment",
      ctaSecondary: "How We Do It",
      stats: [
        {
          num: "93%",
          text: "of AI projects stall on the last mile from pilot to production",
        },
        {
          num: "88%",
          text: "of enterprises deploying AI already see positive ROI",
        },
        { num: "2 wks", text: "fastest time-to-value for a quick-win pilot" },
      ],
    },
    hook: {
      lead: "A generic assistant won't move your business. Our Forward Deployed Engineers embed AI deep into your core operations — precise diagnosis, closed-loop optimization, quantified ROI — cutting repetitive labor and amplifying output per person, so AI becomes the growth engine that leaves your competitors behind.",
      cards: [
        {
          title: "Advice, but no execution",
          line1: {
            num: "93%",
            text: "of AI projects stall from pilot to production — great decks that never reach your business systems.",
          },
          line2: {
            num: "2.6×",
            text: "companies that actually get AI running are far likelier to see returns than peers stuck at the slide deck.",
          },
        },
        {
          title: "Missing business-savvy engineers",
          line1: {
            num: "Scarce",
            text: "hybrid talent who understand LLMs, know your industry workflows, and can deliver private deployments.",
          },
          line2: {
            num: "90%",
            text: "of teams lack the engineering muscle to wire models into their existing systems.",
          },
        },
        {
          title: "ROI you can't pin down",
          line1: {
            num: "?",
            text: "sizable investment, hard-to-quantify results — decision-makers hesitate to scale beyond the pilot.",
          },
          line2: {
            num: "88%",
            text: "of enterprises that deployed AI already see positive ROI — most just never measured it.",
          },
        },
        {
          title: "Scattered data & knowledge AI can't use",
          line1: {
            num: "80%",
            text: "of enterprise data is unstructured — scattered across docs, chats and systems the LLM can't reach.",
          },
          line2: {
            num: "0 citations",
            text: "without retrieval and traceability, AI answers aren't trustworthy enough to use in the business.",
          },
        },
        {
          title: "Private deployment that never lands",
          line1: {
            num: "Concern",
            text: "customer, order and operations data can't be handed to public-cloud LLMs — internal security and compliance won't sign off.",
          },
          line2: {
            num: "Hard to build",
            text: "going private means missing GPUs, engineering and ops — high cost, long timelines, and it never goes live.",
          },
        },
        {
          title: "Peaks at launch, never self-grows",
          line1: {
            num: "Static",
            text: "the model freezes at launch — your business shifts and data grows, but the AI doesn't evolve with it.",
          },
          line2: {
            num: "Decays",
            text: "without a feedback loop and continuous tuning, results decay over time until the AI becomes shelfware.",
          },
        },
      ],
      doingTitle: "What we do: Advise · Deploy · Build",
      doingDesc:
        "Advise — AI evangelism and consulting, translating LLM capability into growth leverage for your business; Deploy — FDE delivery that gets AI running in your systems; Build — custom Agent development that compounds into reusable assets.",
      checkTitle: "One capability set to close the last mile of AI adoption",
      checklist: [
        "AI evangelism & consulting: translate LLM capability into growth leverage for your business",
        "FDE delivery: from business diagnosis to private deployment, getting AI into your systems",
        "Custom Agent development: compounding into reusable pre-built Agents and connectors",
        "Clear timelines + quantified ROI + compounding assets — solving the last mile",
      ],
    },
    content3: {
      title:
        "Letoo AI plugs LLM capability into your systems<br />with production-ready Agents",
      subtitle:
        "AI as your growth co-pilot — from diagnosis to launch, closing the last mile.",
    },
    content4: {
      title: "Custom Agents for your scenarios, across every industry",
      desc: "Cross-border e-commerce, social content & creator marketing, supply chain, manufacturing, healthcare, legal & corporate/fintax services, and more — we build custom Agents for your scenarios and turn goals into measurable results.",
    },
    whatWeHave: {
      kicker: "LETOO AI · CAPABILITY STACK",
      title: "What we have",
      subtitle: "From an enterprise AI foundation to an organization that keeps evolving, we help AI grow into your business.",
      os: {
        label: "Enterprise AI Operating System",
        title: "The foundation for the whole company to work with AI",
        description: "Built around an Agent collaboration platform with private deployment and deep customization. Hand repetitive work to Agents so every key role has dedicated AI support and the organization can produce more.",
        consoleTitle: "Letu · Enterprise AI Operating System",
        live: "LIVE · 4 AGENTS",
        workspace: ["Organization", "CRM", "Approvals", "Inventory", "Agents"],
        capabilities: [
          { number: "01", title: "Private deployment", description: "Keep data and workflows under your control; core assets stay in your domain." },
          { number: "02", title: "Connect existing systems", description: "Put AI into the workflows you already run instead of starting over." },
          { number: "03", title: "AI for every role", description: "Make AI a collaborator for every role, not a tool for a small group." },
          { number: "04", title: "Extensible architecture", description: "Keep building dedicated Agents as the business grows; the system gets stronger with use." },
        ],
        agents: [
          { name: "Sales Inquiry Agent", status: "RUNNING", metric: "1,486 · 94%", metricLabel: "processed · resolution", bars: [16, 24, 20, 30, 26, 37, 32, 43] },
          { name: "Contract / Quote Agent", status: "RUNNING", metric: "2,760 · 91%", metricLabel: "processed · resolution", bars: [20, 27, 25, 34, 31, 42, 38, 46] },
          { name: "Knowledge Agent", status: "RUNNING", metric: "842 · 97%", metricLabel: "processed · resolution", bars: [12, 18, 25, 20, 32, 29, 40, 36] },
          { name: "Approval Flow Agent", status: "STANDBY", metric: "196 · 88%", metricLabel: "processed · resolution", bars: [13, 17, 21, 29, 26, 34, 38, 45] },
        ],
        autoBuild: "Request → AI Agent builds automatically (self-growing)",
      },
      growth: {
        label: "Self-growing system",
        title: "Let skills, knowledge and workflows keep evolving",
        description: "The model is only the starting point; compounding organizational capability is what matters. We distill the FDE method — diagnose, decompose, deliver and iterate — into reusable Agents so skills, knowledge and workflows accumulate, reuse and improve with every delivery.",
        steps: [
          { number: "01", title: "Record", description: "Capture real workflows, expert judgment and operating steps." },
          { number: "02", title: "Replay", description: "Turn one-off delivery into reusable, auditable workflows." },
          { number: "03", title: "Distill", description: "Transfer expert experience into Agent capability, with humans in the loop." },
          { number: "04", title: "Self-grow", description: "As usage increases, knowledge, skills and workflows keep evolving." },
        ],
        nodes: [
          { index: "01", title: "Real workflow", description: "Capture expert practice", position: "top" },
          { index: "02", title: "Agent execution", description: "Run inside business systems", position: "right" },
          { index: "03", title: "Outcome review", description: "Record results and exceptions", position: "bottom" },
          { index: "04", title: "Method capture", description: "Turn results into reusable capability", position: "left" },
        ],
      },
      cta: "Explore AI solutions",
    },
    whatWeDo: {
      title: "What we do",
      subtitle: "From seeing the current state to continuous evolution, we put AI into your business and compound it into reusable organizational assets.",
      eyebrow: "AI-native delivery system",
      pillarsAria: "Capability path",
      mapAria: "AI delivery path from the current state through an AI-native foundation and method system to measurable outcomes",
      pillars: [
        { key: "know", title: "Know", description: "AI evangelism and consulting: understand your business and find the highest-leverage opportunities." },
        { key: "act", title: "Act", description: "FDE delivery: turn diagnosis, development, integration and launch into measurable business outcomes." },
        { key: "build", title: "Build", description: "Custom Agent development: build intelligent assets that collaborate, execute and compound over time." },
      ],
      map: {
        currentLabel: "Your current state",
        baseLabel: "AI-native foundation",
        resultLabel: "Measurable outcomes",
        stages: [
          { title: "Legacy system upgrade", description: "Assess the current state and migrate workflows to restore productivity in old systems.", side: "current" },
          { title: "FDE consulting plan", description: "Map scenarios around business goals and define priorities and the path to launch.", side: "current" },
          { title: "Diagnosis", description: "A one-week deep diagnosis to align the current state with the target and produce an executable plan.", side: "method" },
          { title: "Build from 0 to 1", description: "Decompose requirements, deliver end to end and launch the first working scenario.", side: "method" },
          { title: "Agent collaboration platform", description: "A private, controllable and extensible foundation for multiple Agents to work together.", side: "method" },
          { title: "AI Knowledge Base", description: "Turn enterprise knowledge and business experience into a reliable foundation for Agents to retrieve, understand and act.", side: "method" },
          { title: "Delivery and launch", description: "Connect to real systems and deliver AI that is usable, measurable and ready to run.", side: "result" },
          { title: "Review and evaluate", description: "Validate outcomes with data and keep improving workflows, models and collaboration.", side: "result" },
          { title: "Self-evolution", description: "Turn every delivery into skills, knowledge and workflows that get stronger with use.", side: "result" },
        ],
      },
      foundation: {
        title: "AI-native foundation",
        description: "Agent collaboration platform",
        tags: ["Knowledge base", "Connectors", "FDE method"],
        loopLabel: "FDE method loop",
        loopSteps: ["Diagnose", "Decompose", "Deliver", "Review"],
      },
      deliverablesTitle: "What we deliver",
      deliverablesEyebrow: "Delivery scope",
      stageArrowLabel: "View stage details",
      deliverables: [
        "AI evangelism and consulting to build the right mindset and delivery method",
        "FDE delivery and private deployment that puts AI into your systems",
        "Custom Agents, Skills and connectors that compound into reusable assets",
        "Clear timelines, quantified ROI and capability that compounds over time",
      ],
      cta: "Explore AI solutions",
    },
    flow: {
      title: "FDE delivery flow: from diagnosis to compounding assets",
      steps: [
        "Business Diagnosis",
        "Scenario Selection",
        "2–4 Week Quick-Win Pilot",
        "Private Deployment",
        "Scale & Compound",
      ],
    },
    content6: {
      block1Title: "Execution, not advice — we get the job done for you",
      block1Desc:
        "FDE delivery, from business diagnosis to private deployment, with clear timelines and quantified ROI. Not a PPT — a working AI running inside your systems.",
      block1List: [
        "Business diagnosis & scenario selection",
        "Private deployment & integration",
        "Post-launch impact measurement & iteration",
      ],
      block2Title: "Compounding assets that save more over time",
      block2Desc:
        "Every delivery compounds into pre-built Agents, evaluation sets, SOPs, Skills & MCP connectors and anonymized datasets — making the next scenario faster and cheaper.",
      block2List: [
        "Reusable Agents & connectors",
        "Industry SOPs & evaluation sets",
        "Marginal costs that shrink with scale",
      ],
      ctaText: "Tell us about your business — let's see where AI can land",
    },
    knowledge: {
      title: "AI Knowledge Base: put your enterprise knowledge to real use",
      subtitle:
        "Turn the know-how scattered across docs, systems and people's heads into an asset everyone can find and use — cutting costs, speeding up service, and keeping expertise from walking out the door.",
      cards: [
        {
          title: "Faster response, better service",
          desc: "Support, pre-sales and after-sales get instant answers — your senior staff's expertise made available to everyone, with faster, more consistent replies and happier customers.",
        },
        {
          title: "New hires ramp up fast",
          desc: "Policies, processes and scripts all in one place — far shorter onboarding and lower training and trial-and-error costs.",
        },
        {
          title: "Expertise that stays",
          desc: "Turn your key people's tacit know-how into a company asset, so staff turnover no longer walks off with core knowledge.",
        },
        {
          title: "Decisions you can trust",
          desc: "Every answer is traceable to its source and access-controlled — reliable, secure and compliant, so business decisions are fast and sound.",
        },
      ],
      flowTitle: "How it lands",
      flow: [
        "Business Diagnosis",
        "Scenario Selection",
        "2–4 Week Quick-Win Pilot",
        "Private Deployment",
        "Scale & Compound",
      ],
      ctaText: "Let's put your knowledge base to work — tell us your scenario",
    },
    // Core-value dashboard module (rendered above "Advise · Deploy · Build"); figures are illustrative placeholders
    coreValue: {
      title: "What we bring you",
      subtitle: "Turn every execution into measurable efficiency, cost savings and growth—so value is visible and stands up to review.",
      tags: ["Native intelligence", "Stable & reliable", "Intelligent upgrade"],
      impact: {
        badge: "LIVE",
        label: "Tech spend · 30 days",
        value: "80%",
        unit: "lower overall tech spend",
        note: "like saving a whole in-house tech team with an AI-Native model",
        axisStart: "90 days ago",
        axisEnd: "now",
      },
      roi: {
        title: "roi",
        rows: [
          { label: "Custom systems replace SaaS subscriptions", metric: "software subscription cost saved", value: "60%" },
          { label: "Internal ops systems automated", metric: "manual reporting hours cut", value: "90%" },
          { label: "From monthly reports to live dashboards", metric: "faster business decisions", value: "2x" },
        ],
      },
      agents: {
        title: "agents · failure rate",
        note: "running last 30 days · lower failure rate is better",
        list: [
          { name: "Sourcing Agent", rate: "0.7%", pct: 47 },
          { name: "Replenishment Agent", rate: "0.4%", pct: 27 },
          { name: "Reconciliation Agent", rate: "0.2%", pct: 13 },
          { name: "Logistics Agent", rate: "1.3%", pct: 87 },
        ],
        more: "12 more Agents running",
      },
      delivery: {
        title: "delivery",
        label: "In 2 weeks",
        fast: { value: "2 weeks", desc: "fastest delivery to live" },
        resp: { value: "20 min", desc: "fastest response to a new request" },
        compare: {
          rows: [
            { label: "Traditional", value: "months", pct: 90, brand: false },
            { label: "Letoo AI", value: "2 weeks", pct: 16, brand: true },
          ],
        },
      },
    },
  },
  courses: {
    hero: {
      eyebrow: "AI FDE COURSES · FROM INSIGHT TO DELIVERY",
      title: "Don't just learn to use AI.\nLearn to deliver it into the business.",
      description: "From business diagnosis and scenario decomposition to Agent delivery and continuous iteration, build an AI FDE method you can reuse at work.",
      primaryCta: "Learn about personal courses",
      secondaryCta: "Learn about enterprise training",
      stats: [
        { value: "3", label: "tracks", caption: "Career · Enterprise · ", accent: "Technical" },
        { value: "19", label: "modules", caption: "7 career · 9 enterprise · 3 technical" },
        { value: "3+", label: "projects", caption: "Email assistant · ReAct · SWE-bench" },
        { value: "200+", label: "", caption: "Reusable Skills" },
        { value: "4", label: "stages", caption: "Diagnose · Decompose · Deliver · Iterate" },
        { value: "1", label: "use case", caption: "Real business delivery" },
      ],
      preview: {
        title: "Letoo Academy · AI FDE course",
        eyebrow: "COURSE WORKSPACE · PREVIEW",
        stages: [
          { id: "diagnose", number: "01", label: "Diagnose", title: "Find the AI use case worth doing first", description: "Start with business goals, pain-point frequency and measurable value to decide what AI should solve first.", lesson: "Lesson 01 · Use-case diagnosis", task: "Identify the real business bottleneck", progress: "24%", status: "2 / 4 tasks complete" },
          { id: "decompose", number: "02", label: "Decompose", title: "Turn a complex problem into a testable MVP", description: "Break a large goal into a smallest scenario with clear roles, data, actions and acceptance criteria.", lesson: "Lesson 02 · Scenario decomposition", task: "Define the smallest deliverable scope", progress: "46%", status: "3 / 5 tasks complete" },
          { id: "deliver", number: "03", label: "Deliver", title: "Put an Agent into a real business workflow", description: "Connect models, tools and business actions so an acceptable Agent workflow can actually launch.", lesson: "Lesson 04 · FDE delivery method", task: "Build a reviewable operating loop", progress: "68%", status: "3 / 4 tasks complete" },
          { id: "iterate", number: "04", label: "Iterate", title: "Make the system better with data and review", description: "Use feedback, evaluation and review to turn one delivery into a capability that keeps improving.", lesson: "Lesson 06 · Iteration loop", task: "Design the next evaluation metric", progress: "86%", status: "4 / 5 tasks complete" },
        ],
      },
    },
    outcomes: {
      eyebrow: "WHAT YOU'LL BUILD",
      title: "Take away a running system, not just notes",
      items: [
        { number: "01", title: "Build 1 self-improving AI system", description: "See how business owners, operators, Agents, data and review loops work together so you can reuse the system at work." },
        { number: "02", title: "Build 3+ Agent projects by hand", description: "From an email assistant and ReAct loop to SWE-bench, turn real work into portfolio evidence." },
        { number: "03", title: "Use 200+ reusable Skills", description: "Cover diagnosis, delivery and evaluation by turning expert moves into schedulable, iterable capabilities." },
        { number: "04", title: "Deliver 1 real business use case", description: "Use Diagnose → Decompose → Deliver → Iterate to launch one scenario within a week." },
      ],
    },
    lesson: {
      eyebrow: "INSIDE A LESSON",
      title: "Every page explains what, why and how",
      caption: "Real course workspace",
      features: ["Clear conclusions", "Evidence-backed judgment", "Frameworks ready to use", "Cases that reveal what matters"],
      preview: {
        live: "LIVE NOTES",
        label: "FDE DELIVERY METHOD",
        title: "Turn complex work into an Agent workflow that runs",
        description: "Validate value and feasibility first, then connect people, data, models and actions into a reviewable loop.",
        flow: ["Business problem", "Smallest scenario", "Measurable result"],
        noteLabel: "KEY INSIGHT",
        note: "Make one scenario work before you scale the capability.",
      },
    },
    curriculum: {
      eyebrow: "CURRICULUM",
      title: "A complete course, not a handful of prompts",
      chapterLabel: "Letoo Academy · chapter",
      tabs: [
        { id: "personal", label: "Personal · Series A", subtitle: "FDE career training", modules: [
          { code: "M0", title: "Getting started", subtitle: "Don't treat AI as search. Start with the problem it solves.", lessons: "4 lessons", level: "Start" },
          { code: "M1", title: "What is an FDE?", subtitle: "You are not the model. You bring it into the business.", lessons: "4 lessons", level: "Concept" },
          { code: "M2", title: "Business & consulting thinking", subtitle: "Clients buy a solved problem, not another piece of software.", lessons: "5 lessons", level: "Method" },
          { code: "M3", title: "AI capability baseline", subtitle: "Draw the boundary between what AI can and cannot do.", lessons: "6 lessons", level: "Capability" },
          { code: "M4", title: "FDE delivery method", subtitle: "Take on the mission, not a disconnected feature list.", lessons: "5 lessons", level: "Delivery" },
          { code: "M5", title: "FDE full-stack toolkit", subtitle: "Many models exist; choosing the right system is the craft.", lessons: "7 lessons", level: "Practice" },
          { code: "M6", title: "Career positioning & growth", subtitle: "FDE is not the finish line. It trains builders.", lessons: "3 lessons", level: "Growth" },
        ] },
        { id: "enterprise", label: "Enterprise · Series B", subtitle: "Enterprise AI delivery", modules: [
          { code: "M0", title: "Break the ice", subtitle: "Understand AI before you ask it to change the business.", lessons: "3 lessons", level: "Start" },
          { code: "M1", title: "Why AI delivery fails", subtitle: "Most pilots miss returns, but failure has a pattern.", lessons: "4 lessons", level: "Concept" },
          { code: "M2", title: "Diagnose: use-case priority", subtitle: "There are many AI opportunities. Which one comes first?", lessons: "4 lessons", level: "Diagnose" },
          { code: "M3", title: "Decompose: use case to MVP", subtitle: "After choosing a use case, do not start by writing code.", lessons: "4 lessons", level: "Decompose" },
          { code: "M4", title: "Compliance foundation", subtitle: "Compliance is not an appendix. It carries the system.", lessons: "4 lessons", level: "Compliance" },
          { code: "M5", title: "Deliver: launch in a week", subtitle: "A demo is not delivery until it can be accepted and launched.", lessons: "5 lessons", level: "Deliver" },
          { code: "M6", title: "Iterate: self-running loop", subtitle: "Consultants leave; the system needs to keep running.", lessons: "4 lessons", level: "Iterate" },
          { code: "I", title: "Industry pack: legal", subtitle: "Anchor the AI delivery framework in real legal work.", lessons: "4 lessons", level: "Industry" },
          { code: "C", title: "Industry pack: support", subtitle: "AI support is more than adding another chatbot.", lessons: "4 lessons", level: "Industry" },
        ] },
        { id: "technical", label: "Technical · Series C", subtitle: "Agent engineering", modules: [
          { code: "C1", title: "Build an Agent from zero", subtitle: "An Agent is a loop, state and constraints—not a persona.", lessons: "5 lessons", level: "Foundation" },
          { code: "C2", title: "Frameworks & RAG engineering", subtitle: "Compare core frameworks and deploy RAG safely.", lessons: "6 lessons", level: "Intermediate" },
          { code: "C3", title: "Evaluation, multi-Agent & launch", subtitle: "Move from usable to evaluated, orchestrated and launched.", lessons: "5 lessons", level: "Advanced" },
        ] },
      ],
    },
    framework: { eyebrow: "FRAMEWORKS", title: "Learn the methods we use to deliver", cards: [
      { eyebrow: "METHOD", title: "The four-stage FDE loop" },
      { eyebrow: "USE-CASE SELECTION", title: "Value × feasibility priority" },
      { eyebrow: "THE FDE ROLE", title: "FDE vs. other roles" },
    ], priority: { xLabel: "Feasibility", yLabel: "Value", low: "Avoid", high: "Do first", best: "Priority" }, comparison: {
      roles: ["FDE", "Consultant", "Engineer"], rows: [
        { label: "Business", values: ["full", "full", "empty"] },
        { label: "Engineering", values: ["full", "empty", "full"] },
        { label: "Embedded delivery", values: ["full", "half", "empty"] },
        { label: "Owns outcomes", values: ["full", "half", "half"] },
      ],
    }, steps: [
      { number: "01", title: "Diagnose", description: "Build a use-case priority map" },
      { number: "02", title: "Decompose", description: "Move from use case to testable MVP" },
      { number: "03", title: "Deliver", description: "Connect real workflows and launch" },
      { number: "04", title: "Iterate", description: "Create a compounding operating loop" },
    ] },
    programIntro: {
      eyebrow: "PERSONAL COURSE · SERIES A · FDE CAREER TRAINING",
      titleLead: "FDE is the AI era's",
      titleAccent: "super-individual",
      description: "A Forward Deployed Engineer embeds in the field to bring AI into real business. Created by Palantir and pursued by YC, it is one of China's scarcest, highest-premium emerging roles.",
    },
    programs: { eyebrow: "TWO PATHS · PROGRAMS", title: "Grow your craft, build your system", cards: [
      { key: "personal", eyebrow: "PERSONAL · SERIES A", title: "Become an FDE who can deliver AI into the business", audience: "For engineers, product people and business talent making the transition", bullets: ["FDE model: business, engineering and delivery", "Full-stack toolkit and real Agent projects", "Learning community, Q&A and portfolio review"], price: "from ¥588", cta: "Learn about personal courses" },
      { key: "enterprise", eyebrow: "ENTERPRISE · SERIES B", title: "Turn team expertise into a reusable system", audience: "For founders, partners, business leaders and teams", bullets: ["Standard curriculum plus your real business exercise", "Industry packs and an Agent/Skill capability map", "Diagnosis, review templates and iteration loop"], price: "from ¥21,800 / team", cta: "Learn about enterprise training" },
    ] },
    pricing: {
      eyebrow: "ENROLL",
      title: "Choose how far you want to go",
      personalTitle: "Personal courses",
      enterpriseTitle: "Enterprise training",
      featuredLabel: "Recommended",
      personal: [
        { name: "Standard", price: "¥588", originalPrice: "was ¥699", features: ["7 complete curriculum modules", "Live online sessions and recordings", "Learning community and Q&A"] },
        { name: "Pro", price: "¥888", originalPrice: "was ¥1,299", features: ["Everything in Standard", "Guided real-delivery project", "Portfolio review and growth guidance"], featured: true },
      ],
      enterprise: [
        { name: "Squad · ≤20 people", price: "¥21,800", features: ["Full standard curriculum", "One industry pack", "Team diagnosis and review templates"] },
        { name: "Department · 21–50 people", price: "¥31,800", features: ["Full standard curriculum", "Two industry packs and business exercise", "Agent role map and Skills map"], featured: true },
        { name: "Company · 51–100 people", price: "¥51,800", features: ["Tiered teaching for multiple teams", "Method distillation framework", "KPI board and ongoing-support interface"] },
        { name: "Custom business edition", price: "from +¥10,000", features: ["Teams over 100 people", "Private deployment and long-term support", "Tailored to business scenarios"] },
      ],
      cta: "Discuss a course plan",
    },
    faq: { eyebrow: "FAQ", title: "Leave the uncertainty to us", items: [
      { question: "Can beginners take the personal course?", answer: "Yes. The curriculum starts with business scenarios and methods; the technical track is better suited to learners with development experience." },
      { question: "How is enterprise training different from the public course?", answer: "Enterprise training uses your real business scenarios and combines industry packs, diagnosis and review templates." },
      { question: "Is the course online or in person?", answer: "Personal learning is primarily online. Enterprise training can be arranged online or on site." },
      { question: "Which tools are covered?", answer: "The curriculum covers models, Agents, RAG, evaluation and common business connections. Exact tools follow the final course plan." },
    ] },
    closing: { eyebrow: "GET STARTED", title: "Make AI truly grow into your business", primaryCta: "Learn about personal courses", secondaryCta: "Learn about enterprise training" },
  },
  solutions: {
    industries: {
      eyebrow: "AI adoption across industries",
      title: "Built for every industry",
      subtitle: "From cross-border commerce to legal and fintax, one AI adoption method shaped around the reality of each business.",
      items: [
        { name: "Cross-border E-commerce", description: "Connect product research, ads, content, support and supply with AI so global teams find opportunities faster and keep conversion growing." },
        { name: "Social Content, Operations & Creator Marketing", description: "Turn trend research, script production, creator selection and campaign reviews into a repeatable, measurable content engine." },
        { name: "Supply Chain", description: "Connect procurement, warehousing, orders and finance with AI to speed up handoffs, flag exceptions and reduce manual work." },
        { name: "Manufacturing", description: "Turn production knowledge, quality workflows and equipment data into executable Agents that improve shop-floor efficiency and delivery reliability." },
        { name: "Healthcare", description: "Make R&D, compliance, medical references and market intelligence easier to search and coordinate within strict access controls." },
        { name: "Legal, Corporate Services & Fintax", description: "Automate contract review, invoice classification, policy research and voucher drafts so experts can focus on higher-value judgment." },
        { name: "Materials / Chemical Plants", description: "Connect process knowledge, quality checks, production planning and safety management to improve shop-floor coordination and delivery reliability." },
        { name: "High-tech Chips", description: "Turn R&D documents, test data and process flows into searchable knowledge for faster issue resolution and project collaboration." },
        { name: "Energy", description: "Connect equipment maintenance, production scheduling and operating data to identify risks earlier and improve energy operations." },
        { name: "Engineering & Real Estate", description: "Coordinate project plans, sourcing, contracts and site progress so cross-team delivery stays transparent and controlled." },
      ],
    },
    title: "Solutions Across Four Industries",
    subtitle: "Custom Agents for your scenarios — clear timelines, quantified ROI",
    items: [
      {
        title: "Cross-border E-commerce",
        subtitle: "Not another AI tool — a 24/7 AI e-commerce team",
        intro:
          "You set strategy, give direction and check results; hand the repetitive product research, ad ops, copy and support to Agents — in as little as 2 weeks, 5 people can output like a full ops team.",
        pains: [
          { pain: "Product & competitor tracking done by hand — endless Excel copy-paste", solution: "Product Agent scrapes bestsellers and competitors 24/7 and auto-generates hot-product/opportunity reports" },
          { pain: "Ad ops rely on people watching dashboards to adjust bids and swap creatives", solution: "Ad Agent monitors ROI in real time, adjusting bids and iterating creatives in seconds" },
          { pain: "Can't keep up writing Listings / storefront copy and SEO", solution: "Copy Agent produces native multilingual copy at scale, with SEO keywords built in" },
          { pain: "Overseas creator outreach is slow — mass emails and manual follow-ups", solution: "Creator Agent auto-discovers influencers and handles personalized outreach and follow-ups in bulk" },
          { pain: "Multilingual support shifts, refunds and returns are exhausting", solution: "Support Agent speaks many languages, responds in seconds and handles returns automatically" },
          { pain: "Restocking, reconciliation and product data are disconnected", solution: "Supply & Pricing Agents auto-trigger restocking and price changes from sales data to protect margin" },
        ],
        team: {
          title: "One AI e-commerce team, many Agents in sync",
          subtitle: "A Supervisor Agent breaks down goals, assigns work to each Agent and watches for anomalies — you set goals and check results",
          roles: [
            { name: "Product Agent", role: "Research", desc: "Bestsellers / market trends / competitor gaps" },
            { name: "Ad Agent", role: "Ads", desc: "Ad placement / budget tuning / ROI optimization" },
            { name: "Store Agent", role: "Ops", desc: "Product listing / Listing optimization / daily operations" },
            { name: "Support Agent", role: "Service", desc: "Customer replies / after-sales / ticket handling" },
            { name: "Pricing Agent", role: "Pricing", desc: "Competitor monitoring / price adjustment / margin protection" },
            { name: "Supervisor Agent", role: "Supervisor", desc: "Breaks down goals / assigns to Agents / watches anomalies & reports" },
          ],
        },
        security:
          "Private deployment keeps your product, customer and order data in your own domain, with controllable, auditable permissions — safer than multi-tenant AI SaaS.",
        roi: "3–4 week pilot; upgrade from a pile of tools to an AI team — output per person rises sharply and wasted manual work drops. See related cases under \"Cases\".",
      },
      {
        title: "Social Content & Creator Marketing",
        subtitle: "Content at scale + creator ROI attribution",
        sections: [
          {
            title: "Core Pain Points",
            description:
              "Heavy multi-account content and compliance pressure, topic/script work reliant on people, unclear creator-campaign ROI.",
          },
          {
            title: "AI FDE Use Cases",
            description:
              "Batch content production and compliance review, Xiaohongshu/Douyin topic & script Agent, TikTok / Instagram creator outreach and social selling, creator screening and an ROI-attribution dashboard.",
          },
          {
            title: "Typical Agent Capabilities",
            description:
              "Multi-account content factory, risk-control review, script generation, TikTok/Instagram creator screening and DM outreach, campaign attribution analysis.",
          },
          {
            title: "Expected ROI & Timeline",
            description:
              "2–4 week pilot; content output doubles, manual effort drops, wasted spend converges.",
          },
        ],
      },
      {
        title: "Supply Chain",
        subtitle: "Give your supply chain an AI workforce: order entry, procurement, warehousing and reconciliation — hand it the repetitive work",
        intro:
          "It doesn't replace people, only the repetitive work — AI workers plus your team, freeing people for higher-value judgment; live in as little as 2 weeks.",
        pains: [
          { pain: "Customers place messy orders in chats — manual entry is slow and error-prone", solution: "Order Agent recognizes, splits and creates orders into your ERP, and answers chats 24/7" },
          { pain: "Churn signals hide in order history and chats — sales notice too late", solution: "Sales Agent scores customer health, flags churn early and assigns follow-up tasks" },
          { pain: "Procurement planning relies on experience; quoting and supplier coordination are tedious", solution: "Procurement Agent forecasts demand, sends bulk RFQs/POs and flags exceptions" },
          { pain: "Inventory alerts lag; picking and processing rely on people watching", solution: "Warehouse Agent sends daily inventory reports and connects picking/processing via software + hardware" },
          { pain: "Month-end reconciliation, invoicing and quoting eat time", solution: "Finance Agent auto-reconciles, invoices per customer rules and quotes with margin in seconds" },
          { pain: "Operating data lags — the boss can't get real-time numbers", solution: "Management Agent answers business questions in one line and pushes daily revenue/margin/at-risk-customer reports" },
        ],
        team: {
          title: "One AI supply-chain workforce, many Agents in sync",
          subtitle: "Six workgroups, enabled as needed — covering everything from order entry to the management dashboard",
          roles: [
            { name: "Order & Support", role: "Customer Ops", desc: "Auto order entry from chats / 24/7 customer chat / receipt recognition" },
            { name: "Sales Management", role: "Sales", desc: "Customer health analysis / churn warnings / follow-up assignment" },
            { name: "Procurement", role: "Procurement", desc: "Demand forecasting / bulk RFQ & PO / supplier coordination" },
            { name: "Warehouse", role: "Warehouse", desc: "Daily inventory reports / picking & processing (incl. hardware)" },
            { name: "Finance", role: "Finance", desc: "Quote calculation / reconciliation / invoice verification" },
            { name: "Management", role: "Management", desc: "One-line business queries / daily reports / AI worker summaries" },
          ],
        },
        security:
          "Private deployment integrated with your existing ERP keeps orders, customers, suppliers and inventory in your own domain.",
        roi: "3–4 week pilot; hours for entry/reconciliation/procurement drop sharply, mis-shipments fall markedly, and output per person clearly rises.",
      },
      {
        title: "Legal, Corporate Services & Fintax",
        subtitle: "Hand repetitive compliance & bookkeeping to AI",
        sections: [
          {
            title: "Core Pain Points",
            description:
              "Hard-to-classify irregular invoices, time-consuming first-pass contract review, fast-changing local tax policies that are hard to verify.",
          },
          {
            title: "AI FDE Use Cases",
            description:
              "Invoice smart-classification + subject matching + voucher drafts, contract tax/risk-clause review, precise RAG Q&A on tax policy.",
          },
          {
            title: "Typical Agent Capabilities",
            description:
              "Invoice recognition and classification, voucher generation, clause-risk flagging, policy knowledge-base retrieval.",
          },
          {
            title: "Expected ROI & Timeline",
            description:
              "3–4 week pilot; bookkeeping/first-pass hours cut by half, policy-verification costs drop noticeably.",
          },
        ],
      },
    ],
  },
  cases: {
    heroTitle: "AI adoption takes delivery, not slogans",
    heroSubtitle:
      "From cross-border e-commerce to legal, corporate services and fintax, every case starts with a real business scenario and proves AI value through a clear timeline and measurable results.",
    title: "Cases",
    subtitle: "Execution, not advice — every case has clear timelines and quantified results",
    disclaimerNote: "Some cases are anonymized demonstrations.",
    contactCta: "Share your needs and explore similar cases",
    list: [
      // —— Cross-border E-commerce ——
      {
        description:
          "A South China 3C cross-border seller facing insufficient multi-platform Listing capacity and slow responses to competitor negative reviews. In a 3-week FDE delivery, we shipped a multi-platform Listing optimization and competitor-review monitoring Agent, integrated into their operations workspace.",
        tag: "AI adoption case",
        rightText: [
          {
            title: "Use Cases",
            textArr: [
              "Batch multi-platform Listing optimization",
              "Real-time competitor negative-review monitoring & alerts",
              "One-click adoption of suggestions in the ops workspace",
            ],
          },
          {
            title: "Delivery",
            textArr: ["FDE delivery, 3-week pilot", "Private deployment, integrated with existing ops systems"],
          },
        ],
        footerInfo: [
          "Listing output efficiency ↑300%",
          "Conversion rate ↑18%",
          "Competitor-review response cut from days to hours",
        ],
      },
      {
        description:
          "A DTC store on Shopify with a high cart-abandonment rate and frequent chargeback disputes. In a 4-week FDE delivery, we shipped a cart-recovery + chargeback-warning Agent.",
        tag: "AI adoption case",
        rightText: [
          {
            title: "Use Cases",
            textArr: ["Automated cart-abandonment recovery outreach", "High-risk order chargeback warnings", "Auto-generated support scripts"],
          },
          {
            title: "Delivery",
            textArr: ["FDE delivery, 4-week pilot", "Integrated with Shopify and payment risk control"],
          },
        ],
        footerInfo: ["Cart recovery rate ↑22%", "Chargeback disputes ↓35%", "Recovery shifted from manual to automated"],
      },
      {
        description:
          "A home-goods brand going global with inefficient overseas creator outreach and low cold-email reply rates. In a 3-week FDE delivery, we shipped a TikTok creator auto-discovery + personalized cold-email Agent.",
        tag: "AI adoption case",
        rightText: [
          {
            title: "Use Cases",
            textArr: [
              "TikTok creator auto-discovery & profiling",
              "Personalized cold-email generation",
              "Outreach progress dashboard",
            ],
          },
          { title: "Delivery", textArr: ["FDE delivery, 3-week pilot"] },
        ],
        footerInfo: ["Creator outreach volume ↑5×", "Cold-email reply rate ↑40%", "Outreach automated from manual screening"],
      },
      // —— Social Content & Creator Marketing ——
      {
        description:
          "A beauty MCN agency under heavy multi-account content and compliance-review pressure. In a 3-week FDE delivery, we shipped a batch content-production and compliance-review Agent.",
        tag: "AI adoption case",
        rightText: [
          {
            title: "Use Cases",
            textArr: ["Batch content production across accounts", "Automated content compliance review", "Asset library & scheduling integration"],
          },
          { title: "Delivery", textArr: ["FDE delivery, 3-week pilot"] },
        ],
        footerInfo: ["Content output ↑4×", "Manual effort ↓50%", "Compliance review moved upstream, risk down sharply"],
      },
      {
        description:
          "A local-services merchant heavily reliant on manual topic and script work, unable to reliably reproduce viral hits. In a 2-week FDE delivery, we shipped a Xiaohongshu/Douyin topic & script Agent.",
        tag: "AI adoption case",
        rightText: [
          {
            title: "Use Cases",
            textArr: ["Platform trending-topic mining", "Automated storyboard script generation", "Structured capture of viral-content elements"],
          },
          { title: "Delivery", textArr: ["FDE delivery, 2-week pilot"] },
        ],
        footerInfo: ["Viral-hit rate ↑2×", "Topic-to-final-draft cycle greatly shortened", "Viral methods captured as reusable templates"],
      },
      {
        description:
          "An FMCG brand unable to attribute creator-campaign ROI, with a lot of wasted spend. In a 4-week FDE delivery, we shipped a creator-screening and ROI-attribution dashboard.",
        tag: "AI adoption case",
        rightText: [
          {
            title: "Use Cases",
            textArr: ["Creator screening & risk assessment", "Multi-dimensional campaign ROI attribution", "Budget-reallocation recommendations"],
          },
          { title: "Delivery", textArr: ["FDE delivery, 4-week pilot"] },
        ],
        footerInfo: ["Wasted spend ↓30%", "ROI now quantifiable and reviewable", "Budget allocation shifted from guesswork to data-driven"],
      },
      // —— Supply Chain ——
      {
        description:
          "An East China agricultural-products distributor with slow, error-prone entry of non-standard WeChat orders (voice/handwritten notes). In a 4-week FDE delivery, we shipped non-standard order → ERP alias-mapping + one-click review cards.",
        tag: "AI adoption case",
        rightText: [
          {
            title: "Use Cases",
            textArr: [
              "Voice/handwritten order parsing",
              "Product alias normalization mapped to ERP",
              "One-click review cards inside WeCom",
            ],
          },
          { title: "Delivery", textArr: ["FDE delivery, 4-week pilot", "Integrated with existing ERP"] },
        ],
        footerInfo: ["Order-entry hours ↓70%", "Mis-shipment rate ↓90%", "Orders shifted from manual entry to auto-structured"],
      },
      {
        description:
          "An industrial-parts distributor spending heavy hours on multimodal goods-receipt reconciliation with laggy inventory alerts. In a 3-week FDE delivery, we shipped a multimodal goods-receipt parsing + inventory-warning Agent.",
        tag: "AI adoption case",
        rightText: [
          {
            title: "Use Cases",
            textArr: ["Image/PDF goods-receipt parsing", "Automated reconciliation with discrepancy flagging", "Inventory-threshold alerts"],
          },
          { title: "Delivery", textArr: ["FDE delivery, 3-week pilot"] },
        ],
        footerInfo: ["Reconciliation hours ↓60%", "Discrepancies caught earlier", "Inventory alerts shifted from reactive to proactive"],
      },
      {
        description:
          "A building-materials supply-chain company with slow cross-department flow between procurement, warehousing and finance. In a 4-week FDE delivery, we shipped a WeCom glue connector linking all three.",
        tag: "AI adoption case",
        rightText: [
          {
            title: "Use Cases",
            textArr: ["Procurement–warehousing–finance WeCom connector", "Automated cross-system document flow", "Automatic exception alerts"],
          },
          { title: "Delivery", textArr: ["FDE delivery, 4-week pilot"] },
        ],
        footerInfo: ["Cross-department flow time ↓65%", "Full audit trail on document flow", "Manual hand-offs greatly reduced"],
      },
      // —— Legal, Corporate Services & Fintax ——
      {
        description:
          "A chain bookkeeping agency spending heavy hours on irregular-invoice classification and voucher entry. In a 3-week FDE delivery, we shipped an invoice smart-classification + account-matching + voucher-draft Agent.",
        tag: "AI adoption case",
        rightText: [
          {
            title: "Use Cases",
            textArr: ["Smart classification of irregular invoices", "Automated accounting-subject matching", "Auto-generated voucher drafts"],
          },
          { title: "Delivery", textArr: ["FDE delivery, 3-week pilot"] },
        ],
        footerInfo: ["Bookkeeping hours ↓55%", "Higher consistency in subject matching", "Vouchers shifted from manual entry to draft review"],
      },
      {
        description:
          "A regional law firm spending long hours on first-pass review of contract tax and risk clauses. In a 4-week FDE delivery, we shipped a contract risk-clause auto-review Agent.",
        tag: "AI adoption case",
        rightText: [
          {
            title: "Use Cases",
            textArr: ["Identification of contract tax clauses", "Automatic risk-clause flagging", "Draft first-pass review opinions"],
          },
          { title: "Delivery", textArr: ["FDE delivery, 4-week pilot"] },
        ],
        footerInfo: ["First-pass review hours ↓50%", "Fewer missed risk clauses", "Lawyers focus on high-value judgment"],
      },
      {
        description:
          "A fintax consultancy facing fast-changing local tax policies and high verification costs. In a 3-week FDE delivery, we shipped a precise-RAG Q&A Agent for tax policy.",
        tag: "AI adoption case",
        rightText: [
          {
            title: "Use Cases",
            textArr: ["Local tax-policy knowledge base", "Precise RAG Q&A with source citations", "Policy-change alerts"],
          },
          { title: "Delivery", textArr: ["FDE delivery, 3-week pilot"] },
        ],
        footerInfo: ["Policy-verification cost ↓40%", "Answers cite policy-article sources", "Faster response to policy updates"],
      },
    ],
  },
  fde: {
    heroTitle:
      "FDE Delivery: <span class='text-gradient'>get AI running in your business</span>",
    heroSubtitle:
      "Forward Deployed Engineers deliver from business diagnosis to private deployment, solving the last mile from pilot to production.",
    whatTitle: "What is an FDE, and why you need one",
    whatCards: [
      {
        title: "93% of projects stall on the last mile",
        desc: "Great decks that never reach your systems. FDEs make it land.",
      },
      {
        title: "Fluent in models and your workflows",
        desc: "Delivery engineers wire AI into your existing systems.",
      },
      {
        title: "Clear timelines, quantified ROI",
        desc: "Not a PPT — a measurable, iterable AI running in your stack.",
      },
    ],
    flowTitle: "Methodology: 4-week quick win, compounding over time",
    flowSteps: [
      "Business Diagnosis",
      "Scenario Selection",
      "2–4 Week Quick-Win Pilot",
      "Private Deployment",
      "Scale & Compound",
    ],
    assetsTitle: "Every delivery compounds into reusable assets",
    assets: [
      { title: "Pre-built Agents", desc: "Industry-ready agents, tuned to your needs." },
      { title: "Eval Harness", desc: "Reusable evals keeping quality stable." },
      { title: "SOP", desc: "Standard playbooks that scale delivery." },
      {
        title: "Skills & MCP Connectors",
        desc: "Reusable connectors to your systems and data.",
      },
      { title: "Anonymized Datasets", desc: "High-quality data that sharpens over time." },
    ],
    loom: {
      eyebrow: "FDE · LOOP",
      title: "Make FDE capability repeatable, not a scaling bottleneck",
      description:
        "Record, replay and distill the senior FDE loop — diagnose, decompose, deliver and iterate — into reusable Agents. Skills, knowledge and workflows keep compounding, freeing people from repetitive execution and turning experience into durable organizational growth.",
      steps: [
        { number: "01", title: "Record", description: "Capture real workflows, expert judgment and operating steps while the work is happening." },
        { number: "02", title: "Replay", description: "Turn one-off delivery into reusable, auditable workflows and repeatable Agents." },
        { number: "03", title: "Distill", description: "Move expert judgment into the Agent: the Agent executes, people stay in the loop." },
        { number: "04", title: "Self-grow", description: "Every run and review improves reuse while knowledge, skills and workflows get richer." },
      ],
      record: {
        windowTitle: "loom · record",
        statusAriaLabel: "Recording status",
        status: "RECORDING",
        timelineLabel: "Workflow timeline",
        timeline: [
          "00:02  Open CRM and filter high-intent leads",
          "00:14  Apply the playbook and generate a quote",
          "00:31  Save to the system and trigger approval",
        ],
      },
      distill: {
        label: "Distill into a reusable Agent",
        prompt: "Turn expert judgment and operating steps into an auditable workflow",
        ariaLabel: "Distillation stage",
      },
      replay: {
        label: "Agent auto-replay",
        status: "RUNNING",
      },
      stats: {
        executionValue: "1,284",
        executionLabel: "executions",
        humanValue: "0",
        humanLabel: "human hand-offs",
        progressLabel: "Reuse keeps rising",
        progressAriaLabel: "Reuse progress",
      },
      workbenchAriaLabel: "FDE Loom workbench",
    },
    useCases: {
      eyebrow: "FDE · USE CASES",
      title: "Typical use cases",
      subtitle: "Three common entry points for businesses — with value you can see from the start.",
      cards: [
        {
          number: "01",
          icon: "store",
          title: "Digital front door upgrade",
          description: "Rebuild your outward presence, inquiry entry points and online conversion so customers trust you at first glance.",
          tags: ["Website / multilingual refresh", "Cross-border commerce & payments", "SEO & inquiry paths", "Landing pages / mini programs"],
        },
        {
          number: "02",
          icon: "plug",
          title: "Connect internal systems and data",
          description: "Turn data scattered across spreadsheets, group chats and legacy tools into business systems people can use, see and decide from.",
          tags: ["Light ERP / finance / approvals", "Break down data silos", "Real-time business dashboards", "Legacy system rebuild"],
        },
        {
          number: "03",
          icon: "workflow",
          title: "Put AI workflows into operation",
          description: "Embed AI into daily operations, remove repetitive work and give every critical role a dedicated AI partner.",
          tags: ["Intelligent service / knowledge base", "Bulk contract & quote generation", "AI sales assistance", "Automated approval flows"],
        },
      ],
      cta: "Start with your scenario →",
    },
    ctaText: "Book a free AI diagnosis and talk through your first quick win",
  },
  about: {
    heroTitle: "About Letoo AI",
    heroP1:
      "Letoo AI focuses on AI evangelism, consulting, FDE delivery, and custom Agent development — solving the last mile of AI adoption.",
    heroP2: "We believe in execution over advice: engineering AI into your business systems.",
    heroP3: "Our mission — the doers of AI adoption, paving the last mile.",
    teamLabel: "Our Team",
    investorsLabel: "Our Partners",
    locationsTitle: "Location",
    locations: [
      {
        name: "Chengdu",
        detail:
          "Room 1407, Unit 1, Bldg 7, No. 399 West Fucheng Ave, Chengdu Hi-Tech Zone, China (Sichuan) Pilot FTZ",
        country: "China",
      },
    ],
    contact: [
      { text: "18180509790" },
      { text: "WeCom: scan to join" },
      { text: "support@letoo.tech" },
    ],
  },
  community: {
    heroTitle:
      "Developer Community: <span class='text-gradient'>turn AI delivery skills into income</span>",
    heroSubtitle:
      "Lead sharing · project work · token distribution · shared skills.",
    valueTitle: "What you get by joining",
    valueCards: [
      {
        title: "Lead Sharing",
        desc: "Real enterprise demand, routed to active developers first.",
      },
      { title: "Project Work", desc: "Outsourced FDE delivery and collaboration." },
      {
        title: "Token Distribution",
        desc: "Model & compute distribution — sell shovels in the AI gold rush.",
      },
      {
        title: "Shared Skills",
        desc: "Shared Pre-built Agents, SOPs, Skills & MCP connectors.",
      },
    ],
    joinTitle: "How to join",
    joinDesc: "Scan to add our WeCom; we'll invite you into the developer community.",
    qrCaption: "WeCom · scan to join",
    rulesTitle: "Community rules",
    rules: [
      "Real identities, genuine collaboration — no spam ads.",
      "Delivery quality first; respect clients and peers.",
      "Share skills and build compounding assets together.",
    ],
    ctaText: "Add our WeCom and see the real opportunities inside",
  },
  footer: {
    description:
      "Forward Deployed Engineers deliver from business diagnosis to private deployment, so AI actually grows into your business.",
    contact: "Contact us",
    groups: {
      product: { title: "Products & services" },
      learn: { title: "Explore Letoo AI" },
    },
    ecosystem: {
      title: "AI delivery ecosystem",
      description:
        "Connect business, Agents, data, and delivery so every AI practice compounds into reusable capability.",
      badge: "AI-native delivery",
    },
    copyright: "© {year} {brand} · All rights reserved",
    bottomNote: "蜀ICP备2026000935号-2",
    publicSecurityFiling: "川公网安备51019002010054号",
  },
  meta: {
    home: {
      title: "Home",
      desc: "Letoo AI: not just advice — we get AI actually growing into your business. FDE delivery, results in as little as 2 weeks.",
    },
    solutions: {
      title: "Solutions",
      desc: "AI adoption solutions across industries: custom Agents by scenario, with clear timelines and quantified ROI.",
    },
    cases: {
      title: "Cases",
      desc: "AI adoption cases across cross-border e-commerce, social media, supply chain, and legal & fintax — clear timelines, quantified ROI.",
    },
    fde: {
      title: "FDE Delivery",
      desc: "Forward Deployed Engineers solving the last mile of AI adoption.",
    },
    community: {
      title: "Community",
      desc: "Join the Letoo AI developer community.",
    },
    about: {
      title: "About",
      desc: "Letoo AI — the doers of AI adoption, paving the last mile.",
    },
  },
};
